module.exports = __webpack_public_path__ + "frxxyy/img/ico.png?99f2dc3b";